if (process.env.REACT_APP_ENV === 'production') console.log = function () {};